"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MAXIMUM_ACTION_BUFFER = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseReporter2 = _interopRequireDefault(require("./BaseReporter"));

var _ReporterActionTypes = _interopRequireDefault(require("./ReporterActionTypes"));

var MAXIMUM_ACTION_BUFFER = 10;
exports.MAXIMUM_ACTION_BUFFER = MAXIMUM_ACTION_BUFFER;

var InAppReporter = /*#__PURE__*/function (_BaseReporter) {
  (0, _inherits2.default)(InAppReporter, _BaseReporter);

  function InAppReporter() {
    var _this;

    (0, _classCallCheck2.default)(this, InAppReporter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InAppReporter).call(this));
    _this.resolved = {};
    _this.actions = [];
    _this.previousAction = null;
    return _this;
  }

  (0, _createClass2.default)(InAppReporter, [{
    key: "finish",
    value: function finish() {
      this.addPageAction('react-rhumb-event', {
        eventName: 'InAppNavigation',
        navigation: this.actions[this.actions.length - 1]
      });
    }
  }, {
    key: "pushRoute",
    value: function pushRoute(routeInfo, status, duration) {
      if (this.previousAction) {
        this.actions.push({
          from: this.previousAction,
          to: routeInfo,
          duration: duration,
          status: status
        });
      }

      if (this.actions.length > MAXIMUM_ACTION_BUFFER) {
        this.actions.shift();
      }

      this.previousAction = routeInfo;
    } // TODO:
    // - handle "redirect imperative" case

  }, {
    key: "report",
    value: function report(action) {
      if (this.resolved[action.payload.entry.id] && action.type !== _ReporterActionTypes.default.CHECKS_CHANGED) {
        return;
      }

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_TIMEOUT_EXPIRED:
        case _ReporterActionTypes.default.ROUTE_ABANDONED:
        case _ReporterActionTypes.default.ROUTE_FAILED:
          {
            var _action$payload = action.payload,
                entry = _action$payload.entry,
                routeSpec = _action$payload.routeSpec;
            var pathname = entry.pathname,
                checks = entry.checks,
                timestamp = entry.timestamp;
            var route = routeSpec.route,
                error = routeSpec.error;
            this.pushRoute({
              pathname: pathname,
              route: route
            }, 'failure', action.type === _ReporterActionTypes.default.ROUTE_FAILED && this.toDuration(checks, timestamp, error) || undefined);
            break;
          }

        case _ReporterActionTypes.default.ROUTE_SUCCEEDED:
          {
            var _action$payload2 = action.payload,
                _entry = _action$payload2.entry,
                _routeSpec = _action$payload2.routeSpec,
                extra = _action$payload2.extra;
            var _pathname = _entry.pathname,
                _checks = _entry.checks,
                _timestamp = _entry.timestamp;
            var _route = _routeSpec.route;
            var scenario = extra.scenario;
            var markers = _routeSpec.success[scenario];
            this.pushRoute({
              pathname: _pathname,
              route: _route,
              scenario: scenario
            }, 'success', this.toDuration(_checks, _timestamp, markers));
            break;
          }

        default:
      }

      switch (action.type) {
        case _ReporterActionTypes.default.ROUTE_STARTED:
        case _ReporterActionTypes.default.CHECKS_CHANGED:
          break;

        default:
          {
            this.resolved[action.payload.entry.id] = true;

            if (this.actions.length > 0) {
              this.finish();
            }
          }
      }
    }
  }]);
  return InAppReporter;
}(_BaseReporter2.default);

exports.default = InAppReporter;